import { ApexOptions } from "apexcharts";
import React from "react";
import Chart from "react-apexcharts";

interface PieChartProps {
  data: Record<string, number>;
  total?: string;
  symbol?: string;
}

const PieChart = ({ data, total, symbol }: PieChartProps) => {
  const labels = Object.keys(data);

  //   capitalize first letter of the labels
  const capitalizeFirstAndLast = (label: string) => {
    if (label.length === 0) return label;

    const words = label.split(" ");
    const capitalizedWords = words.map((word) => {
      if (word.length === 1) return word.toUpperCase();

      const firstChar = word.charAt(0).toUpperCase();
      const middlePart = word.slice(1);

      return firstChar + middlePart;
    });

    return capitalizedWords.join(" ");
  };

  const capitalizedLabels = labels.map(capitalizeFirstAndLast);

  const values = Object.values(data).map((value) => Number(value));

  //   const labels = data.map((item) => item.category_name || "Unknown");
  //   const values = data.map((item) => Number(item.total));

  const options: ApexOptions = {
    chart: {
      type: "donut",
      toolbar: {
        show: false,
      },
      events: {
        dataPointMouseEnter: function (event, chartContext, config) {
          //   const seriesIndex = config.seriesIndex;
          const dataIndex = config.dataPointIndex;
          const selectedDataLabel = labels[dataIndex];
          const selectedValue = values[dataIndex];
          updateCenterText(selectedDataLabel, selectedValue);
        },
      },
    },
    labels: capitalizedLabels,
    title: {
      align: "center",
    },
    tooltip: {
      y: {
        formatter: (val) => `${val}`,
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      position: "bottom",
    },

    colors: labels.map((label) => {
      if (label === "") return "white";
      if (label === "kenya") return "#DC3912";
      if (label === "ethiopia") return "yellow";
      if (label === "sierra leone") return "#0099C6";
      return "#008753";
    }),
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 320,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            name: {
              show: true,
              fontSize: "22px",
              fontFamily: "Helvetica, Arial, sans-serif",
              color: "#373d3f",
              offsetY: -10,
            },
            value: {
              show: false,
              fontSize: "16px",
              fontFamily: "Helvetica, Arial, sans-serif",
              color: "#373d3f",
              offsetY: 16,
              formatter: function (val) {
                return val.toUpperCase();
              },
            },
            total: {
              show: false,
              showAlways: true,
              label: "Total Expenses",
              fontSize: "12px",
              fontFamily: "Helvetica, Arial, sans-serif",
              color: "#373d3f",

              //   formatter: function () {
              //     return symbol + total;
              //   },
            },
          },
        },
      },
    },
  };

  const series = values;

  const updateCenterText = (label: string, value: number) => {
    const centerText = document.getElementById("apexcharts-datalabels");
    if (centerText) {
      centerText.innerHTML = `<span style="font-size: 22px;font-weight: 700">${label}</span><br /><span style="font-size: 16px;">${value}</span>`;
    }
  };

  return (
    <div style={{ maxWidth: "100%", overflow: "hidden" }} className="pt-8">
      <Chart
        options={options}
        series={series}
        type="donut"
        width="100%"
        height="auto"
      />
    </div>
  );
};

export default PieChart;
